import { Mail, MapPin } from "lucide-react";
import Seo from "@/components/Seo";
import Contact from "@/components/Contact";
import { FadeUp, Eyebrow } from "@/lib/motion";

const OFFICES = "Kansas City, MO — Boutique HQ, clients nationwide";

export default function ContactPage() {
  return (
    <main data-testid="contact-page">
      <Seo
        title="Contact ZD Design — Book a Free Strategy Call"
        description="Tell Todd where your business needs to go. Kansas City boutique agency, clients nationwide — send a message or book a free strategy call today."
        path="/contact"
      />

      <section className="grain relative overflow-hidden pb-12 pt-40 md:pb-16 md:pt-48">
        <div className="pointer-events-none absolute -right-40 top-0 h-[420px] w-[420px] rounded-full bg-flame/10 blur-[140px]" />
        <div className="relative mx-auto max-w-7xl px-4 sm:px-8 lg:px-12">
          <FadeUp>
            <Eyebrow>Contact</Eyebrow>
            <h1 className="mt-5 max-w-3xl font-display text-4xl font-extrabold leading-[0.98] tracking-tight text-slate-900 sm:text-5xl md:text-6xl">
              Let's talk<span className="text-flame">.</span>
            </h1>
            <p className="mt-7 max-w-2xl text-lg leading-relaxed text-mist md:text-xl">
              Tell us where you are and where you need to be. Todd reads every
              message himself — no forms disappearing into a void.
            </p>
          </FadeUp>
          <FadeUp delay={0.15}>
            <div className="mt-10 flex flex-wrap items-center gap-3">
              <a
                href="mailto:todd@zddesignagency.com"
                data-testid="contact-page-email-link"
                className="flex items-center gap-2.5 rounded-2xl border border-slate-200 bg-coal/70 px-5 py-3 text-base text-slate-800 transition-all duration-300 hover:-translate-y-0.5 hover:border-flame/50 hover:text-flame"
              >
                <Mail className="h-4 w-4 text-flame" />
                todd@zddesignagency.com
              </a>
              <div
                data-testid="contact-page-offices"
                className="flex items-center gap-2.5 rounded-full border border-slate-200 bg-coal/70 px-5 py-3 text-base text-slate-800"
              >
                <MapPin className="h-4 w-4 shrink-0 text-flame" />
                {OFFICES}
              </div>
            </div>
          </FadeUp>
        </div>
      </section>

      <Contact />
    </main>
  );
}
